import { render } from "./svg-pay.vue?vue&type=template&id=b46ef960"
import script from "./svg-pay.vue?vue&type=script&lang=ts"
export * from "./svg-pay.vue?vue&type=script&lang=ts"
script.render = render

export default script